import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Input } from "components/bootstrap";
import UploadFieldContainer from "./UploadField/UploadFieldContainer";
function UploadCSVFileAdapterFieldSet({ config, setFieldValue }) {
  const { t } = useTranslation("enterprise_lookup");
  const valueLabel = config.multi_value_lookup ? t("adapter_fields.value_columns") : t("adapter_fields.value_column");
  const valueHelp = config.multi_value_lookup ? t("upload_csv_field_set.value_columns_help") : t("upload_csv_field_set.value_column_help");
  const _onFileUpdate = useCallback(
    (fileId) => {
      if (fileId) setFieldValue("config.file_id", fileId);
    },
    [setFieldValue]
  );
  const onInputChange = (e) => {
    setFieldValue(`config.${e.target.name}`, e.target.type === "checkbox" ? e.target.checked : e.target.value);
  };
  return /* @__PURE__ */ React.createElement("fieldset", null, /* @__PURE__ */ React.createElement(
    UploadFieldContainer,
    {
      onUpdate: _onFileUpdate,
      fileId: config.file_id,
      setDisableFormSubmission: () => !!config.file_id,
      accept: ".csv"
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "text",
      id: "separator",
      name: "separator",
      label: t("adapter_fields.separator"),
      required: true,
      onChange: onInputChange,
      help: t("adapter_fields.help_separator"),
      value: config.separator,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "text",
      id: "quotechar",
      name: "quotechar",
      label: t("adapter_fields.quote_character"),
      required: true,
      onChange: onInputChange,
      help: t("adapter_fields.help_quote_character"),
      value: config.quotechar,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "text",
      id: "key_column",
      name: "key_column",
      label: t("adapter_fields.key_column"),
      required: true,
      onChange: onInputChange,
      help: t("adapter_fields.help_key_column"),
      value: config.key_column,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "text",
      id: "value_column",
      name: "value_column",
      label: valueLabel,
      required: !config.multi_value_lookup,
      onChange: onInputChange,
      help: valueHelp,
      value: config.value_column,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "checkbox",
      id: "multi_value_lookup",
      name: "multi_value_lookup",
      label: t("adapter_fields.multi_value_lookup"),
      checked: !!config.multi_value_lookup,
      onChange: onInputChange,
      help: t("adapter_fields.help_multi_value_lookup"),
      wrapperClassName: "col-md-offset-3 col-md-9"
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "checkbox",
      id: "case_insensitive_lookup",
      name: "case_insensitive_lookup",
      label: t("adapter_fields.case_insensitive_lookup"),
      checked: !!config.case_insensitive_lookup,
      onChange: onInputChange,
      help: t("adapter_fields.help_case_insensitive_lookup"),
      wrapperClassName: "col-md-offset-3 col-md-9"
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "checkbox",
      id: "cidr_lookup",
      name: "cidr_lookup",
      label: t("adapter_fields.cidr_lookup"),
      checked: !!config.cidr_lookup,
      onChange: onInputChange,
      help: t("adapter_fields.help_cidr_lookup"),
      wrapperClassName: "col-md-offset-3 col-md-9"
    }
  ));
}
export default UploadCSVFileAdapterFieldSet;
